/**
 * Loads the moment locale for the given locale code
 * @param locale The locale code
 * @returns A promise that resolves when the locale is loaded
 */
export const loadMomentLocale = async (locale: string): Promise<void> => {
    const momentLocale = locale.split('-')[0];

    if (momentLocale !== 'en') {
        try {
            switch (momentLocale) {
                case 'fr':
                    await import('moment/dist/locale/fr');
                    break;
                case 'de':
                    await import('moment/dist/locale/de');
                    break;
                case 'es':
                    await import('moment/dist/locale/es');
                    break;
                case 'it':
                    await import('moment/dist/locale/it');
                    break;
                case 'nl':
                    await import('moment/dist/locale/nl');
                    break;
                case 'tr':
                    await import('moment/dist/locale/tr');
                    break;
                case 'hu':
                    await import('moment/dist/locale/hu');
                    break;
                case 'pt':
                    await import('moment/dist/locale/pt');
                    break;
                default:
                    console.error(`Moment locale not explicitly handled: ${momentLocale}`);
            }
        } catch (error) {
            console.error(`Failed to load moment locale: ${momentLocale}`, error);
        }
    }
};
